import { http } from '@/api/client/httpClient';
import type { TsAlertTemplateDto, TsAlertTemplateListItemDto } from '@/api/types/tsTemplates';

// Finkit.Tenants.User.TraderSurveillance.Templates.TsAlertTemplateLoaderAppService
//   GetEnabledTemplatesAsync -> GET /api/app/ts-alert-template-loader/enabled-templates
//   GetTemplateAsync(id)     -> GET /api/app/ts-alert-template-loader/template?id=
const BASE = '/api/app/ts-alert-template-loader';

export const tsAlertTemplateLoaderApi = {
  getEnabledTemplates: () =>
    http.get<TsAlertTemplateListItemDto[]>(`${BASE}/enabled-templates`).then((r) => r.data),

  getTemplate: (id: number) =>
    http.get<TsAlertTemplateDto>(`${BASE}/template`, { params: { id } }).then((r) => r.data),
};
